import { cn } from '../../../lib/utils'
import { ReactNode } from 'react'

interface GlassPanelProps {
  children: ReactNode
  className?: string
  gradient?: boolean
  hover?: boolean
  padding?: 'none' | 'sm' | 'md' | 'lg'
  onClick?: () => void
}

export function GlassPanel({ children, className, gradient = false, hover = false, padding = 'md', onClick }: GlassPanelProps) {
  const paddings = { none: '', sm: 'p-4', md: 'p-6', lg: 'p-8' }
  return (
    <div
      className={cn(
        'backdrop-blur-xl rounded-2xl border',
        'bg-white/[0.06] border-white/10',
        gradient && 'bg-gradient-card',
        hover && 'transition-all duration-300 hover:bg-white/[0.09] hover:border-white/20 hover:shadow-glow-sky cursor-pointer',
        paddings[padding],
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
